/**
 * API base URL. Set REACT_APP_API_URL in .env.production before npm run build.
 * If unset in production, falls back to same host + /backend.
 */
const LOCAL_API = 'http://localhost/cool/my-app/backend';

export function getApiBaseUrl() {
  const fromEnv = process.env.REACT_APP_API_URL;
  if (fromEnv && String(fromEnv).trim()) {
    return String(fromEnv).trim().replace(/\r/g, '').replace(/\/+$/, '');
  }
  if (process.env.NODE_ENV === 'production' && typeof window !== 'undefined') {
    return `${window.location.origin}/backend`.replace(/\/+$/, '');
  }
  return LOCAL_API;
}

export const API_BASE_URL = getApiBaseUrl();
